import { useClickOutside } from '@btime/react-hooks'
import React from 'react'

import { Col, Grid } from '../../kiti/components/structure/Grid'
import { useEditorState } from './EditorContext'
import Line from '../../kiti/components/helpers/Line'
import LineSeparator from '../../kiti/components/helpers/LineSeparator'
import Link from '../../kiti/components/actions/Link'
import Separator from '../../kiti/components/helpers/Separator'
import Text from '../../kiti/components/presentation/Text'

const EditorMenuFormWrapper = ({ title, children, onRemove, onClose }) => {
  const { size, setMenu } = useEditorState()
  const wrapperRef = React.useRef()

  const handleRemove = () => {
    if (onRemove) onRemove()
    setMenu()
  }

  const handleClose = () => {
    if (onClose) onClose()
    setMenu()
  }

  // TODO: Move to inside kiti package
  useClickOutside(wrapperRef, { action: () => handleClose() })

  return (
    <div ref={wrapperRef}>
      {size === 'small' ? <Line /> : <LineSeparator weight={4} />}
      <Separator weight={size === 'small' ? 2 : 0}>
        <Grid gap={0.7} align="center">
          <Col flex={1}>
            <Text size={size === 'small' ? 'xxsmall' : 'small'}>{title}</Text>
          </Col>

          {onRemove && (
            <Col>
              <Link onClick={handleRemove}>
                <Text size={size === 'small' ? 'xxsmall' : 'xsmall'} bold color="red">
                  Excluir
                </Text>
              </Link>
            </Col>
          )}

          <Col>
            <Link onClick={handleClose}>
              <Text size={size === 'small' ? 'xxsmall' : 'xsmall'} bold color="green">
                Salvar
              </Text>
            </Link>
          </Col>
        </Grid>
        <Separator weight={2} />
        {children}
      </Separator>
    </div>
  )
}

export default EditorMenuFormWrapper
